<template>
  <form class="flex flex-col flex-auto justify-between" @submit.prevent="next">
    <MdlTextfield
      ref="username"
      class="block"
      :floating-label="trans('E-mail or mobile (incl. country code)')"
      :error="usernameError || errorMessage"
      @focus="errorMessage = null"
      v-model="username"
      autofocus
    />

    <template v-if="isSent">
      <p>{{ trans('passwords.sent') }}</p>
      <MdlTextfield
        ref="password"
        class="block"
        mono
        :floating-label="trans('Temporary password')"
        :error="passwordError"
        v-model="password"
      />

      <Captcha class="mt-8" v-model="captcha" />

      <div class="action-bar">
        <MdlButton type="submit" :disabled="loading || !verified" raised primary>
          {{ trans('Log in') }}
        </MdlButton>

        <MdlButton @click="cancel">{{ trans('Back') }}</MdlButton>
      </div>
    </template>

    <template v-else>
      <div class="action-bar">
        <MdlButton type="submit" :disabled="loading || !username" raised primary>
          {{ trans('Send new password') }}
        </MdlButton>

        <MdlButton @click="cancel">{{ trans('Back') }}</MdlButton>
      </div>
    </template>
  </form>
</template>

<script>
import { trans } from '@/munio/i18n'
import MdlButton from '@component/mdl/Button.vue'
import MdlTextfield from '@component/mdl/Textfield.vue'
import Captcha from '@component/Captcha.vue'

export default {
  components: {
    Captcha,
    MdlButton,
    MdlTextfield,
  },

  data() {
    return {
      errorMessage: null,
      isSent: false,
    }
  },

  computed: {
    loading() {
      return this.$store.state.loading
    },

    username: {
      get() {
        return this.$store.state.username
      },

      set(value) {
        this.$store.commit('updateUsername', value)
      },
    },

    usernameError() {
      return this.$store.state.usernameError
    },

    password: {
      get() {
        return this.$store.state.password
      },

      set(value) {
        this.$store.commit('updatePassword', value)
      },
    },

    captcha: {
      get() {
        return this.$store.state.captcha
      },
      set(value) {
        this.$store.commit('captcha', value)
      },
    },

    passwordError() {
      return this.$store.state.errors.password
    },

    page() {
      return this.$store.state.page
    },

    verified() {
      return window.Munio.config.captcha.valid || !!this.$store.state.captcha
    },
  },

  methods: {
    trans,

    cancel() {
      this.password = null
      this.$store.commit('loading', false)
      this.$store.commit('navigate', 'login')
    },

    next() {
      if (this.isSent) this.login()
      else this.recover()
    },

    async recover() {
      this.isSent = false
      this.password = ''
      this.errorMessage = null
      this.$store.commit('loading', true)

      try {
        await Munio.api.auth.recover(this.username)
        this.isSent = true
        this.$nextTick(() => this.$refs.password.focus())
      } catch (err) {
        this.errorMessage = err.response.data.error.message
      }

      this.$store.commit('loading', false)
    },

    login() {
      return this.$store.dispatch('login')
    },
  },
}
</script>
